import * as _ from 'lodash'
import {IBusinessObject, IBusinessObjectCreateLoadOptions} from '../PA.Core/PA.Core.IF.BO';
import {ASync} from "../PA.Core/Basic/ASync";
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_CustomerHierarchyLevelRow,
    WB_CustomerHierarchyRow, WB_CustomerHierarchySalesAreaRow, WB_DistribChannelRow,
    WB_DivisionRow,
    WB_MasterDataSetRow,
    WB_SalesAreaRow,
    WB_SalesOrgRow,
    WB_SourceRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbCustomerHierarchy} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Customer_Hierarchy,
    esWB_Customer_Hierarchy_Level, esWB_Customer_Hierarchy_SalesArea,
    esWB_DistribChannel,
    esWB_Division,
    esWB_MasterData_Set,
    esWB_SalesArea,
    esWB_SalesOrg,
    esWB_Source
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {
    CreateOptions,
    ESRecordResolver
} from "../PA.Core/lib/ESRecordResolver";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {BehaviorSubject} from "rxjs";
import {CustomerHierarchyBOValidations} from "./CustomerHierarchyBO.Validation";

export class CustomerHierarchyBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_CustomerHierarchy: WB_CustomerHierarchyRow;

    constructor(options?: IBusinessObjectCreateLoadOptions) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New CustomerHierarchy'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_CustomerHierarchy = null;
        this.IHaveSalesAreas_init();

    }

    get WB_CustomerHierarchy(): WB_CustomerHierarchyRow
    {
        return this.drWB_CustomerHierarchy
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: IBusinessObjectCreateLoadOptions): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating CustomerHierarchy");
        let internalOnComplete = this._OnLoadComplete = (async () => {
            try {
            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new CustomerHierarchy.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                return self;
            }

            // Create record using dbContext

                let newCustomerHierarchyRow: WB_CustomerHierarchyRow= <WB_CustomerHierarchyRow>await self.dbContext.createRecordWithKey(esWB_Customer_Hierarchy)
                newCustomerHierarchyRow.setDefaults()
                newCustomerHierarchyRow.cif.WB_CUST_HIER_ID=options.sId
                newCustomerHierarchyRow.cif.WB_CUST_HIER_NAME=options.sName
                newCustomerHierarchyRow.cif.WB_MDSET_ID= options.wbMasterDataSetId||0

                self.drWB_CustomerHierarchy = newCustomerHierarchyRow;
                self.dbContext.add(esWB_Customer_Hierarchy, newCustomerHierarchyRow)
                self.Identity.setAll(self.WB_CustomerHierarchy.cif.WB_CUSTH_ID, self.WB_CustomerHierarchy.cif.WB_CUST_HIER_ID, self.WB_CustomerHierarchy.cif.WB_CUST_HIER_NAME);
                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                self.Identity.listenToRecordUpdates(self.WB_CustomerHierarchy, 'WB_CUSTH_ID','WB_CUST_HIER_ID','WB_CUST_HIER_NAME')

                self._bIsLoaded = true;
                self._OnLoadComplete = null;
                await self.applyCreateOptions()
                self.Identity.setAll(self.WB_CustomerHierarchy.cif.WB_CUSTH_ID, self.WB_CustomerHierarchy.cif.WB_CUST_HIER_ID, self.WB_CustomerHierarchy.cif.WB_CUST_HIER_NAME);
                self.LoadProgressProvider.finish();
                return self

                } catch (err) {
                    self.LoadProgressProvider.exception(err)
                    return self
                }

            })();

        return internalOnComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        var self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        if(!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading CustomerHierarchy (' + anId + ')')

        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, reject) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if(self.bIsLoaded) {
                var sError = "CustomerHierarchy already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new CustomerHierarchy.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            if ("RecordResolver" in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve();
            } else {
                recordResolver = CustomerHierarchyBO.createRecordResolver({
                    dbContext: self.dbContext
                });
                recordResolverLoadPromise = CustomerHierarchyBO.setupRecordResolver(recordResolver, [anId]);
            }

            recordResolverLoadPromise
                .then(() => {
                    const aCustomerHierarchyRow: any = recordResolver.get(esWB_Customer_Hierarchy, anId);

                    if(_.isEmpty(aCustomerHierarchyRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_CustomerHierarchy = aCustomerHierarchyRow;
                    self.Identity.setAll(self.WB_CustomerHierarchy.cif.WB_CUSTH_ID, self.WB_CustomerHierarchy.cif.WB_CUST_HIER_ID, self.WB_CustomerHierarchy.cif.WB_CUST_HIER_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_CustomerHierarchy, 'WB_CUSTH_ID','WB_CUST_HIER_ID','WB_CUST_HIER_NAME')
                    self.drWB_CustomerHierarchy.cif.MAN
                })
                .then(() => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    reject(err);
                });

        });

        return this._OnLoadComplete;
    }



    async applyCreateOptions(){
        const self = this
        // Set Master Data Set
        let wbMasterDataSet = self.CreateOptions?.wbMasterDataSetId || self.LoadOptions?.wbMasterDataSetId
        if (_.isNumber(wbMasterDataSet)) {
            let mds: WB_MasterDataSetRow = <any>await self.dbContext.find(esWB_MasterData_Set, wbMasterDataSet)
            if (mds) {
                self.WB_CustomerHierarchy.WB_MasterDataSetRow = mds
                self.WB_CustomerHierarchy.cif.WB_MDSET_ID = wbMasterDataSet
            }
        }
        // Set Source
        let wbSource = self.CreateOptions?.wbSourceId || self.LoadOptions?.wbSourceId
        if (_.isNumber(wbSource)) {
            let src: WB_SourceRow = <any>await self.dbContext.find(esWB_Source, wbSource)
            if (src) {

                self.WB_CustomerHierarchy.cif.SOURCE_ID = src.cif.SOURCE_ID
            }
        }

        // Add SalesArea
        let wbSalesAreaId = self.CreateOptions?.wbSalesAreaId || self.LoadOptions?.wbSalesAreaId
        if (_.isNumber(wbSalesAreaId) && !_.isArray(wbSalesAreaId))
            wbSalesAreaId = [wbSalesAreaId]
        for (let aSalesAreaId of (wbSalesAreaId || [])) {
            let newRec = await self.addSalesArea(aSalesAreaId)
        }
    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_CustomerHierarchy.cif.WB_CUST_HIER_NAME + "(" + self.WB_CustomerHierarchy.cif.WB_CUST_HIER_ID + ")");
        try {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if(self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate CustomerHierarchy.";
                self.ValidateProgressProvider.exception(sError);
                throw sError;
            }

            await  CustomerHierarchyBOValidations.ValidateFields(self)
            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self._bIsValidated = false;
            } else {
                self._bIsValidated = true;
            }
            self.ValidateProgressProvider.finish();

        } catch (err) {
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);

        }
        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbCustomerHierarchy = <IwbCustomerHierarchy>self.drWB_CustomerHierarchy;
        this.SaveProgressProvider.start("Saving " + wbCustomerHierarchy.WB_CUST_HIER_ID + "(" + wbCustomerHierarchy.WB_CUST_HIER_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save CustomerHierarchy.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            let tasks: Promise<any>[] = [];
            let bDone = false;

            self.Validate({})
                .then((ignore) => {
                    if (!self.bIsValidated) {
                        self._bIsSaved = false;
                        bDone = true;
                        self.SaveProgressProvider.finish();
                        resolve(self);
                        return;
                    }
                }).then((ignore)=> {
                    if (bDone) return
                    return saveFunction(esWB_Customer_Hierarchy, self.drWB_CustomerHierarchy, {})
                        .then(() => {
                            tasks.push(saveFunction(esWB_Customer_Hierarchy_Level, this.WB_CustomerHierarchy.WB_CustomerHierarchyLevelRows));
                            tasks.push(saveFunction(esWB_Customer_Hierarchy_SalesArea, this.WB_CustomerHierarchy.WB_CustomerHierarchySalesAreaRows));
                            return Promise.all(tasks);
                        })
                        .then((ignored) => {
                            if (bDone) return;

                            if (bBatch) {
                                self.dbContext.addBatchCompleteListener(() => {
                                    self._bIsSaved = true;
                                })
                            } else {
                                self._bIsSaved = true;
                            }
                            self.SaveProgressProvider.finish();
                            resolve(self);
                        })
                        .catch((err) => {
                            self.SaveProgressProvider.exception(err);
                            resolve(self)
                        })
            })
        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbCustomerHierarchy = <IwbCustomerHierarchy>self.drWB_CustomerHierarchy;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbCustomerHierarchy.WB_CUST_HIER_ID+ "(" + wbCustomerHierarchy.WB_CUST_HIER_ID+ ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the CustomerHierarchy

            // 2. If Valid, mark all the records for deletion.
            self.drWB_CustomerHierarchy.markDeleted()
            _.forEach(self.drWB_CustomerHierarchy.WB_CustomerHierarchySalesAreaRows,(a) => a.markDeleted())
            _.forEach(self.drWB_CustomerHierarchy.WB_CustomerHierarchyLevelRows,(a) => a.markDeleted())


            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc = "Sales Area">

    _salesAreasChanged: BehaviorSubject<CustomerHierarchyBO>

    IHaveSalesAreas_init() {
        this._salesAreasChanged = new BehaviorSubject<CustomerHierarchyBO>(this)
    }

    get SalesAreasChanged(): BehaviorSubject<CustomerHierarchyBO> {
        return this._salesAreasChanged
    }

    async addSalesArea(wbSalesAreaId: number): Promise<WB_CustomerHierarchySalesAreaRow> {
        const self = this

        for (let rel of self.WB_CustomerHierarchy.WB_CustomerHierarchySalesAreaRows) {
            if (!rel.isActive)
                continue
            if (rel.cif.WB_SALESAREA_ID == wbSalesAreaId)
                return rel
        }

        let saRow: WB_SalesAreaRow = await self.dbContext.find(esWB_SalesArea, wbSalesAreaId)
        if (_.isEmpty(saRow))
            return undefined

        if (saRow.cif.WB_SALESORG_ID > 0) {
            let soRow: WB_SalesOrgRow = <any>await self.dbContext.find(esWB_SalesOrg, saRow.cif.WB_SALESORG_ID)
            if (!_.isEmpty(soRow) && _.isEmpty(saRow.WB_SalesOrgRow)) {
                saRow.WB_SalesOrgRow = soRow
            }
        }

        if (saRow.cif.WB_DIVISION_ID > 0) {
            let dvRow: WB_DivisionRow = <any>await self.dbContext.find(esWB_Division, saRow.cif.WB_DIVISION_ID)
            if (!_.isEmpty(dvRow) && _.isEmpty(saRow.WB_DivisionRow)) {
                saRow.WB_DivisionRow = dvRow
            }
        }

        if (saRow.cif.WB_DISTRIBCHANNEL_ID > 0) {
            let dcRow: WB_DistribChannelRow = <any>await self.dbContext.find(esWB_DistribChannel, saRow.cif.WB_DISTRIBCHANNEL_ID)
            if (!_.isEmpty(dcRow) && _.isEmpty(saRow.WB_DistribChannelRow)) {
                saRow.WB_DistribChannelRow = dcRow
            }
        }

        let newRow: WB_CustomerHierarchySalesAreaRow = <any>await self.dbContext.createRecordWithKey(esWB_Customer_Hierarchy_SalesArea)
        newRow.setDefaults()
        newRow.WB_CustomerHierarchyRow = self.WB_CustomerHierarchy
        newRow.cif.WB_CUSTH_ID = self.WB_CustomerHierarchy.cif.WB_CUSTH_ID
        newRow.WB_SalesAreaRow = saRow
        newRow.cif.WB_SALESAREA_ID = wbSalesAreaId

        self.SalesAreasChanged.next(self)
        return newRow
    }

    async removeSalesArea(wbCustHSRId: number): Promise<void> {
        const self = this

        for (let rel of self.WB_CustomerHierarchy.WB_CustomerHierarchySalesAreaRows) {
            if (!rel.isActive)
                continue
            if (rel.cif.WB_CUSTHSR_ID == wbCustHSRId) {
                rel.markDeleted()
                break
            }
        }

        self.SalesAreasChanged.next(self)
    }

    //</editor-fold>

    //<editor-fold desc="IHaveRecordResolver -- static">
    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        const opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ("dbContext" in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const customer_hierarchy_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        };

        return new ESRecordResolver(dbContext, customer_hierarchy_options);
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            recordResolver
                .findAllWithRelationships(esWB_Customer_Hierarchy, ids)
                .then(() => {
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    //</editor-fold>

    //<editor-fold desc = "Customer Hierarchy Level operations">
    addCustomerHierarchyLevel(options?: any): Promise<CustomerHierarchyBO> {
        const self = this;
        return new Promise<CustomerHierarchyBO>((resolve, reject) => {
            return self.dbContext.createRecordWithKey(esWB_Customer_Hierarchy_Level)
                .then((aNewRow: WB_CustomerHierarchyLevelRow) => {
                    aNewRow.setDefaults();
                    aNewRow.cif.WB_CUSTH_ID = self.WB_CustomerHierarchy.cif.WB_CUSTH_ID;
                    self.dbContext.add(esWB_Customer_Hierarchy_Level, aNewRow);
                    resolve(self);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    removeCustomerHierarchyLevel(aLevelRowId: number, options?: any): Promise<CustomerHierarchyBO> {
        const self = this;
        return new Promise<CustomerHierarchyBO>((resolve, reject) => {
            _.forEach(self.WB_CustomerHierarchy.WB_CustomerHierarchyLevelRows, (aLevelRow: WB_CustomerHierarchyLevelRow) => {
                if (aLevelRow.isActive && aLevelRow.cif.WB_CUSTH_LEVEL_ID === aLevelRowId) {
                    aLevelRow.markDeleted();
                }
            });
            resolve(self);
        });
    }
    //</editor-fold>

};


PAEnvironment.registerBusinessObjectClass(CustomerHierarchyBO, "CustomerHierarchyBO", "Customer Hierarchy")
